import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register({ name, email, password, ref: sp.get("ref") || undefined });
      toast.success("Kayıt başarılı! Hoş geldin.");
      nav("/panel/satin-al");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Kayıt başarısız");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-panel-bg text-panel-text grid place-items-center px-4 py-10">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8"><Logo size="lg" /></Link>
        <div className="card p-7">
          <h1 className="font-head text-2xl font-bold">Üye Ol</h1>
          <p className="text-sm text-panel-secondary mt-1">Ücretsiz hesap oluştur, saniyeler içinde numara al.</p>
          {sp.get("ref") && <div className="mt-3 text-xs bg-brand/10 text-brand-500 rounded-lg px-3 py-2">Davet kodu ile kayıt oluyorsun 🎉</div>}
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-sm font-medium">Ad Soyad</label>
              <input value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name"
                className="pinput w-full rounded-xl h-12 px-4 mt-1.5 outline-none focus:border-brand-500" placeholder="Adın" />
            </div>
            <div>
              <label className="text-sm font-medium">E-posta</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email"
                className="pinput w-full rounded-xl h-12 px-4 mt-1.5 outline-none focus:border-brand-500" placeholder="ornek@mail.com" />
            </div>
            <div>
              <label className="text-sm font-medium">Şifre</label>
              <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password"
                className="pinput w-full rounded-xl h-12 px-4 mt-1.5 outline-none focus:border-brand-500" placeholder="En az 6 karakter" />
            </div>
            <button disabled={busy} data-testid="register-submit" className="btn-blue w-full rounded-xl h-12 font-semibold">
              {busy ? "Oluşturuluyor..." : "Hesap Oluştur"}
            </button>
          </form>
          <p className="text-sm text-panel-secondary mt-5 text-center">
            Zaten üye misin? <Link to="/giris" className="text-brand-500 font-semibold">Giriş Yap</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
